// @ts-strict-ignore
import { Component } from "@angular/core";

import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { ChannelAddress } from "src/app/shared/shared";

import { ModalComponent } from "./modal";

/**
 * OpenEMS-style flat widget for the HydroSolid Cost-Revenue controller.
 *
 * The flat widget intentionally shows only the two most important values.
 * Details are shown in {@link ModalComponent}.
 */
@Component({
    selector: "Controller_Energy_CostRevenue",
    templateUrl: "./flat.html",
    standalone: false,
})
export class FlatComponent extends AbstractFlatWidget {

    protected override getChannelAddresses(): ChannelAddress[] {
        return [
            new ChannelAddress(this.componentId, "DailyActualTotalCost"),
            new ChannelAddress(this.componentId, "DailyCashflowSavingsVsAllFromGrid"),
        ];
    }

    protected readonly eurConverter = (value: number | null): string => {
        if (value == null) {
            return "-";
        }
        return `${value.toFixed(2)} €`;
    };

    protected async presentModal(): Promise<void> {
        const modal = await this.modalController.create({
            component: ModalComponent,
            componentProps: {
                componentId: this.componentId,
            },
        });

        await modal.present();
    }
}
